const HEALTH_QUERY = `
  query {
    healthCheckPlatform {
      level
      message
    }
  }
`

const healthCheckQueries = {
  methods: {
    async healthCheck() {
      try {
        const result = await this.graphQuery(HEALTH_QUERY, undefined, true)
        const {level, message} = result.healthCheckPlatform
        return {level, message}
      } catch (error) {
        throw new Error(error)
      }
    },
  },
}

export default healthCheckQueries
